import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ConfigPageComponent } from '../core/types/common/ConfigPageComponent';
import Security from './Security';

const queryClient = new QueryClient();

const Index = (props: ConfigPageComponent) => {
    return (
        <QueryClientProvider client={queryClient}>
            <Security />
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};

export default Index;
